import { useEffect } from 'react'

export const marketingSlogans = [
  'Beautiful FF&E Schedules Made Simple'
]

export const usePageTitle = (title: string) => {
  useEffect(() => {
    document.title = title + ' | SprintSpec'
  }, [title])
}
